angular.module('rjmNg.directives').directive "fileUploadList", [
  "$url"
  ($url) ->
    restrict: "E"
    templateUrl: "directive.fileUploadList.html"
    replace: false
    scope: {
      isUpdating: "="
    }
    controllerAs: "view"
    bindToController: true
    controller: [
      "app"
      "fileUploadService"
      (
        app
        fileUploadService
      ) ->

        view = @

        view.fileUploadList = []
        view.clientId = app.getClientId()
        view.baseUrl = $url("")
        view.isUpdating = true

        fileUploadService.listFiles()
        .then ({data}) ->
          for file in data
            view.fileUploadList.push file
          view.isUpdating = false
        .catch (error) ->
          view.isUpdating = false

        view
    ]
]
